import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useNetRevenueSummary = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.netRevenueSummary, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getNetRevenueSummary(), {
        params,
      });

      const composeResponse = {
        clinicNetRevenue: res.data.data.clinic_net_revenue_summary,
        providerNetRevenue: res.data.data.provider_net_revenue_summary,
      };
      return composeResponse;
    },
    options,
  );
};
